import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Cards',
  setup(__props) {

const termsAndConditionsLoader = () => import('~/core/components/regulations/terms-and-conditions/Cards.vue');

return { __sfc: true,termsAndConditionsLoader }
}

})